import { makeObservable, observable, action } from 'mobx';
import { DateRange } from 'react-day-picker';

export class DatePickerStore {
    public selectedDate: DateRange | undefined = undefined;
    public isOpen: boolean = false;
    public wrapperRef: HTMLDivElement | null = null;
    public displayedMonth: Date = new Date();

    public constructor() {
        makeObservable(this, {
            selectedDate: observable,
            isOpen: observable,
            displayedMonth: observable,
            setSelectedDate: action,
            setDisplayedMonth: action,
            open: action,
            close: action,
            toggle: action,
        });
    }

    public setSelectedDate = (date: DateRange | undefined): void => {
        this.selectedDate = date;
        const dateFrom = date?.from;
        const dateTo = date?.to;
        if (dateFrom !== undefined && dateTo !== undefined) {
            this.displayedMonth = new Date(dateFrom.getFullYear(), dateFrom.getMonth(), 1);
        }
    };

    public setDisplayedMonth = (month: Date): void => {
        this.displayedMonth = month;
    };

    public open = (): void => {
        if (this.selectedDate === undefined) {
            const today = new Date();
            this.displayedMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        } else {
            const dateFrom = this.selectedDate.from;
            const dateTo = this.selectedDate.to;

            if (dateFrom !== undefined && dateTo !== undefined) {
                this.displayedMonth = new Date(dateFrom.getFullYear(), dateFrom.getMonth(), 1);
            }
        }
        this.isOpen = true;
    };

    public close = (): void => {
        this.isOpen = false;
    };

    public toggle = (): void => {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    };
}
